import { z } from 'zod';
import { CareDocumentDataSchema } from './CareDocumentDataSchema';
import { IObject } from '../../IObject';
import { dateValidation } from '../../../validation';

export const HealixCareDocumentDataSchema = CareDocumentDataSchema.extend({
  sentToHealixNurse: z
    .object({
      at: dateValidation(),
      by: z.string().nullish(),
    })
    .optional(),
});

export type HealixCareDocumentData = z.infer<
  typeof HealixCareDocumentDataSchema
>;
export type HealixCareDocument =
  IObject.HasIdTimestamped<HealixCareDocumentData>;
